<template>
  <div>
    <div class="cont">
      <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>安全管理</el-breadcrumb-item>
          <el-breadcrumb-item>证件管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="box">
        <div class="box-l">
          <div class="box-l-t">
            <span>全部</span>
            <!-- <div @click="isShow1">新建</div> -->
            <div @click="isShowS">编辑</div>
          </div>
          <div class="box-l-c">
            <el-input size="mini" v-model="activeName" @input="search1" clearable placeholder="请输入内容"></el-input>
          </div>
          <div class="box-l-b">
            <el-tree
              :data="list"
              ref="tree"
              :expand-on-click-node="false"
            :highlight-current="true"
              :props="{children:'child',isLeaf:'leaf'}"
              :node-key="'1value'"
              @node-click="handleNodeClick"
              :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys">
              <span class="custom-tree-node" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <span :title="node.label" style="font-size:14px">{{node.label}}</span>
            </span>
            </el-tree>
          </div>
        </div>
        <div class="box-r">
          <div class="box-r-t">
            <div class="box-r-t-l">
              <div>
                <el-input v-model="fileName" @change="search" clearable placeholder="请输入内容"></el-input>
              </div>
              <div style="margin-left:30px" @click="search">查询</div>
            </div>
            <div class="box-r-t-r">
              <div style="margin-right:10px" @click="downloadS">批量下载</div>
             <div @click="isShowA" style="font-size: 14px;color:#fff">上传</div>
            </div>
          </div>
          <div class="box-r-b">
            <div style="padding:0 8px">
              <el-table
              border
              :header-cell-style="{background:'#F5F7F9',color: '#909399',fontFamily: 'MicrosoftYaHei',fontSize:'16px'}"
              height="66vh"
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="index"
                label="序号"
                width="100"
                >
              </el-table-column>
              <el-table-column
                prop="fileName"
                label="名称"
                >
                <template slot-scope="scope">
                  <div style="overflow: hidden;display:flex">
                    <img v-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='doc'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='docx'" src="../../assets/image/fileImgS/Word.png" alt="">
                    <img v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='xlsx'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='xls'" src="../../assets/image/fileImgS/excel.png" alt="">
                    <img v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='PDF'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='pdf'" src="../../assets/image/fileImgS/PDF.png" alt="">
                    <img v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='png'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='jpg'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='jepg'||scope.row.fileName.split('.')[scope.row.fileName.split('.').length-1]=='jfif'" src="../../assets/image/fileImgS/图片.png" alt="">
                    <img v-else src="../../assets/image/fileImgS/c652d4178d8bd28c62bc4dc8679bcc8.png" alt="">
                    <span @click="showFile(scope.row)" style="font-size:14px;
                    overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
                    margin-left:5px;
                    cursor: pointer;
                    ">{{scope.row.fileName}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="上传时间">
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注">
              </el-table-column>
              <el-table-column
                label="操作"
                width="280">
                <template slot-scope="scope">
                  <div style="display:flex">
                    <el-button @click="download(scope.row)" size="mini" type="primary" plain>下载</el-button>
                    <!-- <el-button @click="isShow2(scope.row)" size="mini" type="primary" plain>批注</el-button> -->
                    <el-button @click="isShowb(scope.row)" size="mini" type="primary" plain>编辑</el-button>
                    <el-button style="margin-left:10px" size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[20, 50, 100, 200,500]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
            <!-- 弹窗 -->
            <el-dialog
            top="26vh"
              title="提示"
              :visible.sync="dialogVisible"
              width="20%"
              >
              <div class="row">
                <div>上级菜单：</div>
                <div>
                  <el-cascader
                  children="child"
                  v-model="form.parentId"
                  size="small "
                  :options="list"
                  :props="{children:'child',checkStrictly: true}"
                  clearable></el-cascader>
                </div>
              </div>
              <div class="row">
                <div>菜单名称：</div>
                <div>
                  <el-input size="small " v-model="form.activeName" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
                <div style="width:2vw"></div>
                <el-button size="mini" type="primary" @click="additem">确 定</el-button>
              </span>
            </el-dialog>
             <el-dialog
              top="26vh"
                title="提示"
                :visible.sync="dialogVisible1"
                width="20%"
                :before-close="handleClose">
                <div class="row">
                  <div>批注内容：</div>
                  <div>
                    <el-input size="small " v-model="remark" placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button size="mini" @click="dialogVisible1 = false">取 消</el-button>
                  <div style="width:2vw"></div>
                  <el-button size="mini" type="primary" @click="additemRemark">确 定</el-button>
                </span>
              </el-dialog>

              <el-dialog
              :title="title"
              :visible.sync="dialogVisible2"
              width="30%"
              >
             <div class="row-x">
               <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHead"
              :data="{ type: 258,
                        partybuildId:listItemId}"
                        :before-upload="beforeUpload"
              :on-success="fileSuccess"
              :file-list="listFile"
              :on-remove="remove">
              <el-button v-if="fileUrl==''" size="small" type="primary">点击上传</el-button>
              </el-upload> 
             </div>
             <div class="row-x" style="margin-top:10px">
              <div class="row-x-l">备注：</div>
              <div class="row-x-r">
                <el-input size="small " v-model="remark" placeholder="请输入内容"></el-input>
              </div>
             </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false">取 消</el-button>
                <el-button v-if="title==='文件上传'" type="primary" @click="downloadA">确 定</el-button>
                <el-button v-else type="primary" @click="downloadb">确 定</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
  export default {
    data() {
      return {
         tableData: [],
          dialogVisible:false,
          dialogVisible1:false,
          form:{
            dataType:'12',
            activeName:'',
            parentId:'',
            createBy:util.session.get('user').id,
            groupId:util.session.get('groupId')
          },
          list:[],
          currentNodekey: '', //默认选中的节点树
          expandedkeys: [], //默认展开的节点树
          listItemId:'',
          uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
          uploadHead: {
            //上传接口header
            accessToken: this.$store.state.token,
          },
          pageSize:20,
          pageNum:1,
          total:0,
          row:{},
          remark:'',
          fileName:'',
          activeName:'',
          dialogVisible2:false,
          title:'文件上传',
          fileUrl:'',
          partybuildId:'',
          fileNameA:'',
          listFile:[]
      }
    },
    mounted(){
      this.getList()
    },
    methods:{
      remove(){
        this.fileUrl=''
      },
      isShowb(item){
        this.listFile=[]
        this.listFile.push({name:item.fileName,url:item.fileUrl})
        this.remark = item.remark
        this.dialogVisible2=true
        this.fileNameA = item.fileName
        this.fileUrl=item.fileUrl
        this.row = item
        this.title='文件修改'
      },
      downloadA(){
        let that = this
         
        if(this.fileUrl==''){
          this.$message({
            type:'warning',
            message:'上传文件不能为空'
          })
          return
        }else if(this.fileUrl=='error'){
          this.$message.error('请修改文件名称！')
          return
        }
        myHttp.createInfoDjWj({
            createBy:util.session.get('user').id,
            fileUrl:this.fileUrl,
            partybuildId:that.listItemId,
            fileName:this.fileNameA,
            remark:that.remark
          }).then(res=>{
            console.log(res,'success')
            if(res.data.code==200){
              that.dialogVisible2=false
              that.getPartyBuildingActiveFileByPartybuildId(that.listItemId)
              this.$message({
                type:'success',
                message:'上传成功'
              })
            }else{
              this.$message({
                type:'warning',
                message:res.data.msg
              })
            }
          })
      },
      downloadb(){
        let that = this
        
        if(this.fileUrl==''){
          this.$message({
            type:'warning',
            message:'上传文件不能为空'
          })
          return
        }else if(this.fileUrl=='error'){
          this.$message.error('请修改文件名称！')
          return
        }
        myHttp.updateInfoDjWj({
            updateBy:util.session.get('user').id,
            fileUrl:this.fileUrl,
            fileName:this.fileNameA,
            id:that.row.id,
            dataType:'12',
            remark:that.remark
          }).then(res=>{
            console.log(res,'success')
            if(res.data.code==200){
              that.dialogVisible2=false
              that.getPartyBuildingActiveFileByPartybuildId(that.listItemId)
              this.$message({
                type:'success',
                message:'修改成功'
              })
            }else{
              this.$message({
                type:'warning',
                message:res.data.msg
              })
            }
          })
      },
      isShowA(){
        this.listFile=[]
        this.fileNameA='',
        this.fileUrl=''
        this.dialogVisible2=true
        this.title='文件上传'
        this.remark=''
        },
      beforeUpload(item){
        if(item.name.split('.')[item.name.split('.').length-1]=='doc'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='docx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='pdf'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='PDF'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xlsx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xls'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='text'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='txt'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='zip'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='rar'){
          return true
        }
        
        this.$message({
          type:'error',
          message:'请上传正确的文件格式（doc,docx,xlsx, xls,pdf,PDF,text,txt，zip，rar，png,jpg,jepg,jfif）'
        })
        return false
      },
      search(){
        this.pageNum = 1
        this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
      },
      search1(){
        console.log(this.activeName,'99999')
        if(this.activeName!=''){
            myHttp.getPartyBuildingActiveByActiveName({
            groupId:util.session.get('groupId'),
            activeName:this.activeName,
            dataType:'12'
          }).then(res=>{
            console.log(res)
            if(res.data.code==200){
              let list = res.data.data
              this.list=[]
              list.forEach(item=>{
                this.list.push({'label':item.activeName,'value':item.parentId})
              })
            }
          })
        }else{
          console.log('1008611')
          this.getList()
        }
      },
      //展示
      showFile(row) {
        var that = this
        window.open(
          base.fileView + '/onlinePreview?url=' + encodeURIComponent(base.httpCtx + row.fileUrl), '_blank'
        )
      },
      downloadS(){
        this.tableData.forEach(item=>{
          let token = util.session.get('token')

        const iframe = document.createElement('iframe')
        iframe.style.display = 'none' // 防止影响页面
        iframe.style.height = 0 // 防止影响页面
        iframe.src = myHttp.downloadFileDj+'?accessToken='+token+'&fileUrl='+base.httpCtx +item.fileUrl+'&fileName='+item.fileName;
        document.body.appendChild(iframe) // 这一行必须，iframe挂在到dom树上才会发请求
        // 之后删除
        setTimeout(() => {
          iframe.remove()
        }, 1000);

       // window.open(myHttp.downloadFileDj+'?accessToken='+token+'&fileUrl='+item.fileUrl+'&fileName='+item.fileName)
        })
      },
      download(item){
        console.log(item)
        let token = util.session.get('token')
        window.open(myHttp.downloadFileDj+'?accessToken='+token+'&fileUrl='+base.httpCtx+item.fileUrl+'&fileName='+item.fileName)
      },
      upd(item){
        this.row=item
      },
      del(item){
        let that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteByIdDj({
            id:item.id
          }).then(res=>{
            console.log(res)
            if(res.data.code==200){
              this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
              this.$message({
                type: 'success',
                message: res.data.msg,
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      getPartyBuildingActiveFileByPartybuildId(item){
        myHttp.getPartyBuildingActiveFileByPartybuildId({
          partybuildId:item,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          fileName:this.fileName,
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let list = res.data.data.list.list
            list.forEach((item,index)=>{
              item.index = (this.pageNum-1)*this.pageSize+index+1
            })
            this.tableData=list
            this.total = res.data.data.list.total
          }
        })
      },
      handleSizeChange(val){
        this.pageSize = val
        this.pageNum = 1
        this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
      },
      handleCurrentChange(val){
        this.pageNum = val
        this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
      },
      fileSuccess(item,i){
        let that = this
        console.log(item,i)
        if(item.code==200){
          this.fileUrl=item.data.saveUrls,
          this.partybuildId=that.listItemId,
          this.fileNameA=i.name
        }else{
          this.fileUrl='error'
          this.$message.error(item.msg)
        }
      },
      fileSuccessS(item,i){
        let that = this
        console.log(item,i)
        if(item.code==200){
          myHttp.updateInfoDjWj({
            updateBy:util.session.get('user').id,
            fileUrl:item.data.saveUrls,
            fileName:i.name,
            id:that.row.id,
            dataType:'12'
          }).then(res=>{
            console.log(res,'success')
            that.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
          })
        }
      },
      handleNodeClick(item){
        console.log(item)
        if(item.parentId==0){
          if(item.child.length!=0){
            this.listItemId=item.child[0].value
          }else{
            this.listItemId=null
            this.tableData=[]
          }
        }else{
          this.listItemId = item.value
        }
        this.pageNum=1
     
        this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
      },
      getList(){
        let that = this
        myHttp.getPartyBuildingByGroupId({
          groupId:util.session.get('groupId'),
          dataType:'12'
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            that.list = res.data.data||[]
            this.getPartyBuildingActiveFileByPartybuildId(that.list[0].value)
            if(res.data.data[0].parentId==0){
              that.listItemId = res.data.data[0].child[0].value||''
            }
            // this.listItemId = that.list.child[0].value
            // that.currentNodekey = res.data.data[0].value
            // that.expandedkeys.push(res.data.data[0].value)
            // that.$nextTick(() => {
            //   // treeBox 元素的ref   value 绑定的node-key
            //   that.$refs.tree.setCurrentKey(that.currentNodekey)
            // })
          }
        })
      },
      isShow1(){
        this.dialogVisible=true
      },
      isShowS(){
        this.$router.push({
          path:'/setTreeData',
          query:{
            dataType:'12',
            name:'证件管理'
          }
        })
      },
      isShow2(item){
        this.row = item
        this.dialogVisible1=true
      },
      additem(){
        let that = this
        if(this.form.parentId==''){
          this.form.parentId='0'
        }else{
          this.form.parentId=this.form.parentId[this.form.parentId.length-1]
        }
        myHttp.createInfoDJ(this.form).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.form.parentId=''
            this.form.activeName=''
            that.getList()
            this.$message({
              type:'success',
              message:res.data.msg
            })
            that.dialogVisible=false
          }else{
            this.$message({
              type:'warning',
              message:res.data.msg
            })
          }
        })
        console.log(this.form)
      },
      additemRemark(){
        let that = this
        if(this.remark==''){
          this.$message({
            type:'warning',
            message:'批注内容不能为空'
          })
          return
        }
        myHttp.setRemark({
          id:that.row.id,
          remark:that.remark
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            that.getList()
            this.$message({
              type:'success',
              message:res.data.msg
            })
            that.dialogVisible1=false
          }
        })
      },
    }
  }
</script>

<style scoped>
.cont{
  width: 100%;
  height: 100%;
  background-color: rgb(236,240,245);
  padding: 0 24px 10px 8px;
}
.title{
  height: 4vh;
  display: flex;
  align-items: center;
}
.box{
  display: flex;
  height: 78vh;
}
.box-l{
  width: 13vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
margin-right:16px ;
}
.box-l-t{
  display: flex;
  height: 4vh;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #ECF0F5;
}

.box-l-t>span{
  font-family: MicrosoftYaHei;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.box-l-t>div{
  width: 40px;
height: 24px;
border-radius: 3px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
align-items: center;
justify-content: center;
}
.box-l-t>div:hover{
  cursor: pointer;
  opacity: 0.7;
}
.box-l-c{
  margin-top: 6px;
  height: 3vh;
  padding: 0 16px;
}
.box-l-b{
  padding-left: 16px;
  /* border: 1px solid; */
  height: 70vh;
  overflow:auto;
}
.box-r{
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  flex: 1;
  overflow: hidden;
}
.box-r-t{
  height: 6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
}
.box-r-t-l{
  /* width: 12vw; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-r-t-r{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-r-t-l>div:nth-child(2),.box-r-t-r>div{
  width: 70px;
height: 40px;
border-radius: 2px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
  justify-content: center;
  align-items: center;
}
.box-r-t-l>div:nth-child(2):hover,.box-r-t-r>div:hover{
  cursor: pointer;
  opacity: 0.7;
}
.box-r-b{
  /* background-color: #f00; */
  height: 72vh;
  
}
.el-pagination{
  box-shadow: 0px -10px 21px 0px rgba(225, 225, 225, 0.3);
}
::v-deep .cell>span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
::v-deep .el-dialog__header{
  text-align: start;
 
background: #F1F1F1;
}
::v-deep .el-dialog__header >.el-dialog__title{
 font-size: 16px ;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.row{
  height: 4vh;
  margin-bottom: 1vh;
  width: 100%;
  display: flex;
  padding-left:1vw;
  align-items: center;
}
.row>div:nth-child(1){
  font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;
}
.row>div:nth-child(2){
  width: 11vw;
  height: 100%;
}
::v-deep .el-dialog{
  border-radius: 6px;
  overflow: hidden;
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
::v-deep .el-tree-node__expand-icon .is-leaf{
  color:transparent !important;
}
.row-x{
  text-align: start;
  display: flex;
  align-items: center;
  padding-left:26%
}
</style>